import { apiInstance } from '../../api';
import { queuesRoute } from './queues.route';

export class ApiApartmentQueuesService {
  static async fetchAllQueues() {
    return apiInstance.get(queuesRoute);
  }
}
